import React from "react";
import { MdOutlineClose } from "react-icons/md";

export const PurchaseResult = ({ mainText, additionalText, onClose }) => {
  return (
    <>
      <div className="flex flex-row justify-end">
        <MdOutlineClose className="text-gray900 size-4" onClick={onClose} />
      </div>

      <div className="mt-4 text-black text-lg font-semibold">{mainText}</div>
      <div className="mt-3 text-start">{additionalText}</div>

      <button
        onClick={onClose}
        className="mt-8 w-full btnGray100 min-h-11 h-11 rounded-full"
      >
        Close
      </button>
    </>
  );
};
